import React from 'react';
import styled from 'styled-components';
import { RawJson } from '../raw-json/raw-json';
import { TableLoader } from '@block-explorer/ui';
import { PageTile } from '@make-software/cspr-design';
import { GetBlockResult } from 'casper-js-sdk';
import {
  AccountRawData,
  ContractDataRawResult,
  GetDeployResult,
  NFTTokenMetadataEntry,
  URefRawData,
} from '@block-explorer/entities';
import { StoredValue } from 'casper-js-sdk/dist/lib/StoredValue';

const StyledWrapper = styled.div(() => ({
  padding: '0 20px',
}));

export interface RawDetailsProps {
  data:
    | GetBlockResult
    | AccountRawData
    | GetDeployResult
    | URefRawData
    | ContractDataRawResult
    | StoredValue
    | NFTTokenMetadataEntry[]
    | undefined
    | null;
  loading: boolean;
  withPageTile?: boolean;
}

export const RawDetails = ({
  data,
  loading,
  withPageTile = true,
}: RawDetailsProps) => {
  if (loading) {
    return <TableLoader columnsLength={1} />;
  }

  const rawDetailsComponent = (
    <StyledWrapper>
      <RawJson json={Object(data)} />
    </StyledWrapper>
  );

  return withPageTile ? (
    <PageTile>{rawDetailsComponent}</PageTile>
  ) : (
    rawDetailsComponent
  );
};
